import dompurify from 'dompurify';

const sanitizer = dompurify.sanitize;

// if allowHtml is set to true, HTML markup will be allowed (to be used in content like email editors)
// if false, the input is fully stripped so that nothing but <br> tags are allowed (to be used in showing simple data like relation name)
export function sanitize(input, allowHtml) {
  if (allowHtml) {
    const sanitized = sanitizer(input, { WHOLE_DOCUMENT: true, USE_PROFILES: { html: true } });
    return sanitized;
  }

  return sanitizer(input, {
    ALLOWED_TAGS: ['br'],
  });
}
